import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { DatabaseFilterParams } from "../../common.model";
import { DatabaserService } from "../../../database/database.service";

@Component({
  selector: "app-databasefilter",
  templateUrl: "./databasefilter.component.html"
})
export class DatabaseFilterComponent implements OnInit {

  @Input()
  loadingData = false;

  @Input()
  filterParams: DatabaseFilterParams;

  filtersCollapsed : boolean;

  @Output()
  onFilterChange = new EventEmitter<DatabaseFilterParams>();

  availableTypes: string[] = [];

  constructor(private databaseService: DatabaserService) {}

  ngOnInit(): void {
    this.databaseService.getTypes().subscribe(types => {
      this.availableTypes = types;


      if (!this.filterParams.types || this.filterParams.types.length === 0) {
        this.filterParams.types = [...this.availableTypes];
      }

      if (this.filterParams.hasSystem === undefined) {
        this.filterParams.hasSystem = null;
      }

      this.emitChanges();
    });
  }

  onTypeChange(event: any): void {
    const value = event.target.value;

    if (event.target.checked) {
      if (!this.filterParams.types.includes(value)) {
        this.filterParams.types = [...this.filterParams.types, value];
      }
    } else {
      this.filterParams.types =
        this.filterParams.types.filter(t => t !== value);
    }

    this.emitChanges();
  }

  isChecked(type: string): boolean {
    return this.filterParams.types?.includes(type);
  }

  setHasSystem(value: boolean | null): void {
    this.filterParams.hasSystem = value;
    this.emitChanges();
  }

  emitChanges(): void {
    this.filterParams.pageNumber = 1;
    this.onFilterChange.emit({
      ...this.filterParams,
      types: [...(this.filterParams.types || [])]
    });
  }


  selectAll(): void {
    if (!this.availableTypes || this.availableTypes.length === 0) {
      return;
    }

    this.filterParams.types = [...this.availableTypes];

    this.emitChanges();
    
  }

  clearAll(): void {
    this.filterParams.types = [];

    this.emitChanges();
  }

  filterChanged(event: any): void {
    this.filterParams.pageNumber = 1;
    this.onFilterChange.emit(this.filterParams);
    
  }
}
